import React from 'react';
import { defineMessages, t } from '@sm/intl';
import { MainNavButton } from '../nav-button';

const COPY = defineMessages({
  MY_SURVEYS: {
    id: 'MySurveys.mySurveys',
    defaultMessage: 'My Surveys',
    description: '[Type: Label][Vis.: low] - My surveys section of nav bar',
  },
});

const MySurveys = () => (
  <MainNavButton href="/surveys/" label={t(COPY.MY_SURVEYS)} />
);

export default MySurveys;
export { MySurveys };
